import React, { useEffect, useRef, useState } from "react";
import "./Form.css";

export default function Form() {

    const [glasses, setGlasses] = useState(1);
    const [weight, setWeight] = useState("");
    const [gender, setGender] = useState("male");
    const [hours, setHours] = useState("");

    const [promillage, setPromillage] = useState("");

    const resultRef = useRef();
    useEffect(() => {
        scrollToResult()
    }, [promillage]);

    function incrementGlasses(amount) {
        if (glasses + amount >= 0) {
            setGlasses(glasses + amount);
        }
    }

    function handleWeightChange(event) {
        if (event.target.value >= 0) {
            setWeight(event.target.value);
        }
    }

    function handleGenderChange(event) {
        setGender(event.target.value);
    }

    function handleHoursChange(event) {
        setHours(event.target.value);
    }

    function handleSubmit(event) {
        event.preventDefault();
        const promillage = calculatePromillage(glasses, weight, gender, hours);
        setPromillage(promillage);
    }

    function scrollToResult() {
        resultRef.current?.scrollIntoView({ behavior: 'smooth' });
    }

    function calculatePromillage(glasses, weight, gender, hours) {
        const genderFactor = { "male": 0.72, "female": 0.61 }[gender] ?? 0.72;
        const a = 0.002 * Math.pow(weight, 2) * genderFactor;
        const promillage = (glasses * 10 - a * (hours - 0.5)) / (weight * genderFactor);
        if (promillage < 0) {
            return 0;
        }
        return promillage;
    }

    function canDrive(promillage) {
        return promillage < 0.2;
    }


    const messages = [
        { promillage: 0.15, message: "Niks aan de hand, je kunt gaan!" },
        { promillage: 0.25, message: "Oke oke het mag nog net, maar pas op!" },
        { promillage: 0.3, message: "Je mag niet meer rijden! Nog een halfuurtje wachten en dan mag je weer." },
        { promillage: 0.35, message: "Gewoon niet doen... zo simpel is het soms..." },
        { promillage: 0.4, message: "Echte sukkels gaan nu rijden, wacht maar tot je weer nuchter bent." },
        { promillage: 0.45, message: "Je bent echt een bozo als je nu gaat rijden." },
        { promillage: 0.5, message: "Kijk als je nou geen beginnersrijbewijs had, dan kon je nu gewoon weg." },
        { promillage: 0.55, message: "Even wachten..... even wachten..... Piz- oh nee geen bier meer voor jou!" },
        { promillage: 0.6, message: "Het is vast gezellig, of niet dan? Doe je riem alvast maar wat strakker." },
        { promillage: 0.65, message: "Als je Mark zou zijn lag je nu zonder twijfel op de grond of te slapen." },
        { promillage: 0.7, message: "Sanity check: heb je wel een rijbewijs? Ik denk het niet." },
        { promillage: 0.75, message: "Ga ff poepen en maak daarna een eitje, en dan ben je weer helemaal goed. Dat is een soort factory reset." },
        { promillage: 0.8, message: "Vraag aas jack in the box terug op stift elleboog op tafel. Jij mag niet rijden!" },
        { promillage: 0.85, message: "Heb jij wel inzicht?" },
        { promillage: 0.9, message: "Tip van flip: drink genoeg anti-kater-water straks." },
        { promillage: 0.95, message: "Vertel je vrienden dat ze alvast een emmer kunnen klaarzetten." }
    ]

    function getPromillageText(promillage) {
        const result = messages.find((key) => promillage <= key.promillage);
        return result?.message ?? "Heb je je broek nog wel aan? Of ligt die op de trap?";
    }

    return (
        <div className="form-shell">
            <form className="card form-card" onSubmit={handleSubmit}>
                <header className="form-header">
                    <h1 className="form-title">Mag Mark nog wel rijden?</h1>
                    <p className="form-subtitle">Vul hieronder je gegevens in en check veilig of je nog mag rijden.</p>
                </header>

                <div className="form-grid">
                    <div className="form-field form-field--full">
                        <label htmlFor="glasses-controls">Aantal glazen</label>
                        <div id="glasses-controls" className="glass-controls">
                            <button type="button" className="glasses_button" onClick={() => incrementGlasses(-1)}>-</button>
                            <button type="button" className="glasses_button" onClick={() => incrementGlasses(1)}>+</button>
                            <p className="glass-count">{glasses} gla{glasses === 1 ? "s" : "zen"}</p>
                        </div>
                        <p className="glass-visual" aria-hidden="true">{"🍺".repeat(glasses)}</p>
                    </div>

                    <div className="form-field">
                        <label htmlFor="weight">Lichaamsgewicht (kg)</label>
                        <input id="weight" required min={20} max={300} type="number" value={weight} onChange={handleWeightChange} />
                    </div>

                    <div className="form-field">
                        <label htmlFor="gender">Geslacht</label>
                        <select id="gender" value={gender} onChange={handleGenderChange}>
                            <option value="male">Man</option>
                            <option value="female">Vrouw</option>
                        </select>
                    </div>

                    <div className="form-field form-field--full">
                        <label htmlFor="hours">Aantal uren sinds eerste glas</label>
                        <input id="hours" required min={0} step="0.5" type="number" value={hours} onChange={handleHoursChange} />
                    </div>
                </div>

                <button className="form-submit" type="submit">Bereken promillage</button>
            </form>

            {promillage !== "" &&
                <section className={`card result-card ${canDrive(promillage) ? "result-card--ok" : "result-card--warn"}`} ref={resultRef}>
                    <p className="result-title">{canDrive(promillage) ? "✅ Ja" : "❌ Nee"}</p>
                    <p className="result-text">{getPromillageText(promillage)}</p>
                    <p className="result-caption">Gebaseerd op een promillage van <span>{Math.ceil(promillage * 100) / 100}‰</span></p>
                </section>
            }

        </div>
    );

}